import salaryList from "./salary-list";
import salaryOrders from "./salaryOrders";
import requestAResponseFromWork from "./requestAResponseFromWork";
import events from "./events";
import certificates from "./certificates";
import school from "./school";
export default {
  namespaced: true,
  modules: {
    salaryList,
    "salary-orders": salaryOrders,
    "request-a-response-from-work": requestAResponseFromWork,
    events,
    certificates,
    school,
  },
};
